module.exports = __webpack_public_path__ + "static/img/scxt-sjk.a315be7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/scxt-sjk.png
// module id = H17V
// module chunks = 0